<template>
  <el-dialog
    width="75%"
    :visible.sync="lookOpen"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div slot="title" class="header">
      <span style="font-size: 25px">会员分组-查看</span>
      <!-- <el-button style="margin-left: 200px" @click.native="downloadTemplateBtn"
        >导入会员模板下载</el-button
      > -->
      <el-button style="margin-left: 200px" @click="memberFreezeImport = true"
        >导入会员</el-button
      >
      <el-button
        icon="el-icon-download"
        @click="(downloadShow = true), getDownladList()"
        >下载导入结果</el-button
      >
      <el-button @click="exportBtn">导出会员</el-button>

      <el-button @click="addToMember(), (SelectMemberVisible = true)"
        >增加会员</el-button
      >
      <el-button @click="deleteBtn">{{ deleteBtnText }}</el-button>
      <el-button @click="clearImport">清空会员</el-button>
    </div>

    <div class="tabs flex-between">
      <div class="left">
        <el-card :body-style="cardHeight">
          <el-form label-width="110px" size="small" style="height: 100%">
            <el-form-item label="分组名称">
              <el-input v-model="leftForm.custGrpName" disabled></el-input>
            </el-form-item>
            <el-form-item label="分组类型">
              <el-input v-model="leftForm.grpKind" disabled></el-input>
            </el-form-item>
            <el-form-item label="分组描述">
              <el-input
                v-model="leftForm.remark"
                type="textarea"
                :rows="5"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="创建人员">
              <el-input v-model="leftForm.createUserName" disabled></el-input>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker
                v-model="leftForm.createTime"
                type="datetime"
                disabled
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="最后修改人员">
              <el-input v-model="leftForm.updateUserName" disabled></el-input>
            </el-form-item>
            <el-form-item label="最后修改时间">
              <el-date-picker
                v-model="leftForm.updateTime"
                type="datetime"
                disabled
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="启用人员">
              <el-input v-model="leftForm.reviewUserName" disabled></el-input>
            </el-form-item>
            <el-form-item label="启用时间">
              <el-date-picker
                v-model="leftForm.reviewTime"
                type="datetime"
                disabled
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="禁用人员">
              <el-input v-model="leftForm.invalidUserName" disabled></el-input>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
      <div class="right">
        <div class="header flex-between">
          <el-form label-width="90px" :inline="true" size="small">
            <el-form-item label="会员卡号\姓名">
              <el-input
                v-model.trim="config.search"
                style="width: 170px"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="维护店">
              <el-input v-model="config.shopCode" clearable></el-input>
            </el-form-item>
            <el-form-item label="当前维护人">
              <el-input v-model="config.shopEmpName" clearable></el-input>
            </el-form-item>
            <el-button
              icon="iconfont icon-sousuo1"
              size="mini"
              style="color: #a19b5a; background-color: #f5f5f5"
              @click="searchBtn"
              >{{ searchBtnText }}</el-button
            >
          </el-form>
        </div>
        <el-tabs type="border-card">
          <el-card shadow="never">
            <el-table
              :show-summary="true"
              :summary-method="getSummaries"
              size="small"
              class="table-style"
              border
              :row-class-name="tableRowClassName"
              :header-cell-style="{
                background: '#FCFBF2',
                'text-align': 'center',
                color: '#6C6839',
              }"
              HEAD
              :cell-style="{ 'text-align': 'center' }"
              ref="multipleTable"
              :data="tableData"
              v-el-table-infinite-scroll="load"
              v-loading="loading"
              infinite-scroll-disabled="onLoading"
              @selection-change="handleSelectionChange"
              @select="handleSelectionCheck"
            >
              <el-table-column type="selection" width="40"> </el-table-column>
              <el-table-column prop="custName" label="顾客姓名">
              </el-table-column>
              <el-table-column prop="cardNo" label="会员卡号">
              </el-table-column>
              <el-table-column prop="levelName" label="顾客等级">
              </el-table-column>
              <el-table-column prop="mobile" label="移动电话">
              </el-table-column>
              <el-table-column prop="shopName" label="维护店">
              </el-table-column>
              <el-table-column prop="shopCode" label="维护门店编码">
              </el-table-column>
              <el-table-column prop="empName" label="当前维护人">
              </el-table-column>
              <el-table-column prop="lastSaleDate" label="最近购买日">
                <template slot-scope="scope">
                  <div v-if="scope.row.lastSaleDate">
                    {{ scope.row.lastSaleDate | dateFormats }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="currYearAmount" label="今年消费金额">
              </el-table-column>
              <el-table-column prop="prevYearAmount" label="去年消费金额">
              </el-table-column>

              <el-table-column prop="currAvailPoint" label="当前积分">
              </el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    style="color: skyblue"
                    @click.native.prevent="
                      tableDeleteBtn(scope.$index, scope.row.custID)
                    "
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>

            <el-alert
              v-if="isMore"
              title="没有更多数据了!"
              type="warning"
              center
              :closable="false"
            >
            </el-alert>
          </el-card>
        </el-tabs>
      </div>
    </div>
    <!-- 导入保存确认对话框 -->
    <div class="import">
      <el-dialog
        title="导入新会员-导入"
        :visible.sync="memberFreezeImport"
        :close-on-click-modal="false"
        append-to-body
        width="40%"
      >
        <div>
          <el-form
            size="mini"
            label-width="155px"
            ref="newUploadForm"
            enctype="multipart/form-data"
          >
            <el-form-item label="选择待导入会员文件">
              <el-row :gutter="10">
                <el-col :span="20">
                  <el-input
                    style="width: 100%"
                    v-model="filename"
                    :readonly="true"
                    placeholder="请选择文件名"
                    disabled
                  >
                  </el-input>
                </el-col>
                <el-col :span="2">
                  <el-upload
                    class="upload"
                    action="#"
                    :show-file-list="false"
                    :on-change="handleExcel"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    :auto-upload="false"
                  >
                    <el-button>选择</el-button>
                  </el-upload>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button icon="el-icon-download" @click="downloadTemplateBtn"
            >下载模板</el-button
          >
        </span>
      </el-dialog>
      <!-- 会员导入下载弹窗 -->
      <!-- <div class="import">
        <el-dialog
          title="导入新会员"
          :visible.sync="deFaultIsDerived"
          :close-on-click-modal="false"
          width="40%"
          append-to-body
        >
          <div class="resui" style="height: 85px">
            <div>成功处理行数: {{ succeedInfo.sucNum }}</div>
            <div style="margin-top: 8px">
              失败处理行数: {{ succeedInfo.errNum }}
            </div>
            <div>
              处理结果文件:
              <span style="text-decoration: underline; color: skyblue">{{
                succeedInfo.fileUrl
              }}</span>
              <el-button
                size
                icon="el-icon-download"
                @click.stop="downFile(succeedInfo.fileUrl)"
                style="margin-left: 10px"
                >下载</el-button
              >
            </div>
          </div>
        </el-dialog>
      </div> -->
    </div>
    <!-- 导入会员下载弹窗 -->
    <el-dialog
      append-to-body
      width="50%"
      :visible.sync="downloadShow"
      title="下载导入结果"
    >
      <el-table
        size="small"
        class="table-style"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="downloadData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <!-- v-loading="loading"
        v-el-table-infinite-scroll="load"
        infinite-scroll-disabled="onLoading" -->
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column
          prop="startTime"
          label="导入开始时间"
        ></el-table-column>

        <el-table-column prop="endTime" label="导入结束时间"></el-table-column>

        <el-table-column prop="isComplate" label="状态">
          <template slot-scope="scope">
            {{ scope.row.isComplate ? "完成" : "执行中" }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="下载">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-download"
              v-if="scope.row.isComplate"
              @click="download(scope.row.downloadUrl)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadShow = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 添加会员弹窗 -->
    <div class="sales">
      <el-dialog
        width="40%"
        :modal-append-to-body="false"
        title="手工分组-增加-选择会员"
        :visible.sync="SelectMemberVisible"
        append-to-body
        lock-scroll
      >
        <div style="width: 28.125rem; margin-top: 0.625rem">
          <el-form size="mini" label-width="12.25rem">
            <el-form-item label="会员姓名\会员卡号\会员电话">
              <div class="flex-between">
                <el-input
                  v-model="formLabelAlign.search"
                  style="width: 18.75rem"
                  clearable
                >
                </el-input>
                <el-button
                  style="
                    width: 5rem;
                    margin-left: 0.625rem;
                    background-color: #f5f5f5;
                    color: #b6b388;
                    border-radius: 0;
                  "
                  size="small"
                  icon="el-icon-search"
                  @click="addToSearch"
                  >{{ searchBtnText }}</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div style="width: 100%; margin-top: 0.625rem">
          <el-table
            size="small"
            height="31.125rem"
            class="table-style"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            HEAD
            :cell-style="{ 'text-align': 'center' }"
            ref="multipleTable"
            :data="tableData2"
            tooltip-effect="dark"
            v-el-table-infinite-scroll="loades"
            infinite-scroll-disabled="onLoadings"
            v-loading="loadings"
            @selection-change="getCurrentRow"
          >
            <el-table-column label width="40" type="selection">
            </el-table-column>
            <el-table-column prop="custName" label="会员姓名">
            </el-table-column>
            <el-table-column prop="cardNo" label="会员卡号"> </el-table-column>
            <el-table-column prop="levelName" label="会员等级">
            </el-table-column>
            <el-table-column prop="regionName" label="所属区域">
            </el-table-column>
            <el-table-column prop="shopName" label="所属门店">
            </el-table-column>
            <el-table-column prop="mobile" label="移动电话"> </el-table-column>
            <el-table-column prop="state" label="状态">
              <template slot-scope="scope">
                {{ scope.row.state === 0 ? "有效" : "无效" }}
              </template>
            </el-table-column>

            <el-alert
              v-if="isMores"
              title="没有更多数据了!"
              type="warning"
              center
              :closable="false"
            >
            </el-alert>
          </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addToSave">{{ confirmButtonText }}</el-button>
          <el-button @click="SelectMemberVisible = false">{{
            cancelButtonText
          }}</el-button>
        </div>
      </el-dialog>
    </div>
  </el-dialog>
</template>
<script>
import { selectCustListApi } from "@/api/shop";
import { mycustDeleteApi } from "@/api/user";
import { reportFormList } from "@/api/reportForm";
import {
  queryGrpListApi,
  importGroundApi,
  clearImportApi,
  insertCustGrpApi,
} from "@/api/marketing";
import { mapState } from "vuex";
export default {
  props: {},
  data() {
    return {
      downloadData: [],
      downloadShow: false,
      cardHeight: { padding: "20px", height: "80vh" },
      radio: "",
      loadings: false,
      loading: true,
      lookOpen: false,
      SelectMemberVisible: false, //选择会员弹窗
      memberFreezeImport: false,
      deFaultIsDerived: false, //导入会员弹窗
      deleteFormVisible: false, //删除弹窗
      SelectChang: {}, //选择的数据
      leftForm: {},
      tableData: [],
      tableData2: [],
      config: {
        //查询
        pageNo: 1,
        pageSize: 50,
        pagesTotal: 0,
        total: 0,
        shopEmpName: "",
        customerGrpID: "",
        shopCode: "",
        search: "",
      },
      // 添加会员弹窗
      formLabelAlign: {
        search: "",
        pageNo: 1,
        pageSize: 50,
        pages: 0,
        total: 0,
      },
      filename: "",
      succeedInfo: [],
      Uitemon: [],
    };
  },
  computed: {
    isMore() {
      return this.tableData.length >= this.config.total;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    ...mapState([
      "searchBtnText",
      "deleteBtnText",
      "confirmButtonText",
      "cancelButtonText",
    ]),
    onLoadings() {
      return this.loadings || this.isMores;
    },

    isMores() {
      return this.formLabelAlign.pageNo >= this.formLabelAlign.pages;
    },
  },
  created() {},
  methods: {
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "";
          return;
        }
        if (index === 2) {
          sums[index] = this.config.total;
          return;
        }
      });

      return sums;
    },
    //获取下载列表数据
    getDownladList() {
      reportFormList({
        groupName: "手工分组会员导入",
      }).then((response) => {
        console.log(response);
        this.downloadData = response.data;
      });
    },
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = process.env.VUE_APP_BASE_API + src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    getCurrentRow(value) {
      this.addTableValue = value;
    },
    tableRowClassName() {},
    handleClose() {
      this.lookOpen = false;
    },
    handleSelectionChange(value) {
      this.Uitemon = value;
    },
    handleSelectionCheck(selection, row) {
      // this.$refs.multipleTable.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.SelectChang = row;
        this.$refs.multipleTable.toggleRowSelection(row, true);
      }
      // console.log(row);
    },
    // 查询
    searchBtn() {
      this.tableData = [];
      // this.tableData2 = [];
      this.config.total = 0;
      this.config.pageNo = 1;
      this.searchList(true);
    },
    // 列表数据
    searchList() {
      let queryInfo = {
        shopEmpName: this.config.shopEmpName,
        customerGrpID: this.$parent.lookGroundList.customerGrpID,
        shopCode: this.config.shopCode,
        search: this.config.search,
        pageNo: this.config.pageNo,
        pageSize: this.config.pageSize,
      };
      queryGrpListApi(queryInfo).then((res) => {
        if (res.success) {
          // if (type == undefined) {
          //   this.tableData = [];
          //   this.tableData2 = [];
          // }
          this.tableData = this.tableData.concat(res.data.list);
          // this.tableData2 = res.data.list;
          this.config.total = res.data.total;
          this.loading = false;
        }
      });
    },
    load() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      setTimeout(() => {
        this.config.pageNo += 1;
        this.searchList();
      }, 500);
    },
    //增加会员滚动加载
    loades() {
      this.loadings = true;
      setTimeout(() => {
        this.formLabelAlign.pageSize += 50;
        this.addToMember();
        this.loadings = false;
      }, 1000);
    },
    // 删除数据
    deleteBtn() {
      if (Object.keys(this.SelectChang) < 2) {
        this.$message({
          message: "请选择数据!",
          type: "warning",
        });
      } else {
        this.$confirm("是否删除?", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        })
          .then(() => {
            let cuarItem = [];
            this.Uitemon.forEach((item) => {
              cuarItem.push(item.custID);
            });
            let cuar = {
              customerGrpID: this.$parent.lookGroundList.customerGrpID,
              custID: cuarItem.join(","),
            };
            mycustDeleteApi(cuar).then((res) => {
              if (res.message == "success") {
                this.$message.success("删除成功!");
                this.deleteFormVisible = false;
                this.searchBtn();
              } else {
                this.$message.error(res.message);
              }
            });
          })
          .catch(() => {
            this.$message.info("取消删除!");
          });
      }
    },

    // 表格的删除按钮
    tableDeleteBtn(index, rows) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
      })
        .then(() => {
          let curDele = {
            customerGrpID: this.$parent.lookGroundList.customerGrpID,
            custID: rows,
          };
          mycustDeleteApi(curDele).then((res) => {
            if (res.message == "success") {
              this.$message.success("删除成功！");
              this.searchBtn();
            }
          });
        })
        .catch(() => {
          this.$message.info("取消删除！");
        });
    },
    // 导入会员模板下载
    downloadTemplateBtn() {
      const e = document.createElement("a");
      e.style.display = "none";
      // 设置href属性为文件路径，download属性可以设置文件名称
      e.href =
        process.env.VUE_APP_BASE_API +
        "/api/templates/会员手工分组导入模板.xlsx";
      e.download = "";
      // 将a标签添加到页面并模拟点击
      document.querySelectorAll("body")[0].appendChild(e);
      e.click();
      // 移除a标签
      e.remove();
    },
    //下载导入成功excel
    // downFile() {
    //   const ele = document.createElement("a");
    //   ele.style.display = "none";
    //   // 设置href属性为文件路径，download属性可以设置文件名称
    //   ele.href = "https://gftest.redstone.com.cn/" + this.succeedInfo.fileUrl;
    //   ele.download = "";
    //   // 将a标签添加到页面并模拟点击
    //   document.querySelectorAll("body")[0].appendChild(ele);
    //   ele.click();
    //   // 移除a标签
    //   ele.remove();
    // },

    // 选择上传
    handleExcel(file) {
      this.filename = file.name;
      let formData = new FormData(); //声明一个FormDate对象
      formData.append("file", file.raw); //添加文件对象
      console.log(formData.get("file"));
      let queryExcel = {
        customerGrpID: this.$parent.lookGroundList.customerGrpID,
      };
      //调用后台导入的接口
      importGroundApi(queryExcel, formData).then((res) => {
        if (res.success == true) {
          this.$message.success("导入成功,请到下载列表中查看");
          // this.deFaultIsDerived = true;
          this.succeedInfo = res.data;
          this.memberFreezeImport = false;
          this.searchList();
        } else {
          // this.deFaultIsDerived = true;
          this.$message({
            type: "error",
            message: "导入失败,请重新导入!",
          });
        }
      });
    },
    // 导出会员
    exportBtn() {
      const e = document.createElement("a");
      e.style.display = "node";
      // e.href =
      //   `https://gftest.redstone.com.cn/api/cust/grplist/exportCust?` +
      //   `customerGrpID=${this.$parent.lookGroundList.customerGrpID}`;
      e.href =
        `${process.env.VUE_APP_BASE_API}/api/cust/grplist/exportCust?` +
        `customerGrpID=${this.$parent.lookGroundList.customerGrpID}`;
      e.download = "";
      document.querySelectorAll("body")[0].appendChild(e);
      e.click();
      e.remove();
    },
    // 清除会员
    clearImport() {
      this.$confirm("是否要清空全部会员?", "提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
      })
        .then(() => {
          clearImportApi({
            customerGrpID: this.$parent.lookGroundList.customerGrpID,
          }).then((res) => {
            console.log(res);
            if (res.success) {
              this.$message.success("清除导入会员成功!");
              this.tableData = [];
              this.tableData2 = [];
              this.config.pageNo = 1;
              this.config.total = 0;
              this.pagesTotal = 0;
              setTimeout(() => {
                this.searchBtn();
              }, 500);
            }
          });
        })
        .catch(() => {
          this.$message.info("撤销清空!");
        });
    },
    // 选择会员窗口查询信息
    async addToMember() {
      await selectCustListApi(this.formLabelAlign).then((res) => {
        if (res.success) {
          this.formLabelAlign.pages = res.data.pages;
          this.tableData2 = res.data.list;
          // console.log(res.data.pages);
          this.formLabelAlign.total = res.data.total;
        }
      });
    },
    // 添加会员搜索
    addToSearch() {
      this.tableData2 = [];
      this.formLabelAlign.pageNo = 1;
      this.formLabelAlign.total = 0;
      this.addToMember();
    },
    // 添加会员保存
    addToSave() {
      let arr = [];
      this.addTableValue.forEach((item) => {
        arr.push(item.custID);
      });
      let addQuery = {
        customerGrpID: this.$parent.lookGroundList.customerGrpID,
        custIDs: arr.toString(),
      };
      insertCustGrpApi(require("qs").stringify(addQuery)).then((res) => {
        if (res.success) {
          this.$message.success("添加会员成功!");
          this.SelectMemberVisible = false;
          this.tableData = [];
          this.config.pageNo = 1;
          this.pagesTotal = 0;
          this.config.total = 0;
          this.searchList();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__footer {
  height: 60px;
  background-color: #f2f2f2;
}
.card-pagination {
  margin-top: 10px;
  text-align: right;
}
.left {
  width: 25%;
}
.right {
  width: 75%;
  margin-left: 10px;
}
/deep/input {
  border-radius: 0 !important;
}
::v-deep {
  .el-tabs__item.is-active {
    color: #a19b5a !important;
  }
  .el-tabs__item:hover {
    color: #a19b5a !important;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }
  .el-table .success-row {
    background: #ffffff;
  }
  .el-textarea__inner {
    // 取消拉伸样式
    resize: none;
  }
}
</style>
